import { combineReducers } from 'redux';
// slices
import customersReducer from './customers/customers.slice';
import partnersReducer from './partners/partners.slice';
import accountSetupReducer from './partners/accountSetup.slice';
import relationshipManagerReducer from './partners/relationshipManager.slice';
import usersReducer from './users/users.slice';
import teamsReducer from './teams/teams.slice';
import whatsAppReducer from './whatsApp/whatsApp.slice';
import gmbReducer from './GMB/Gmb.slice';
import reportsReducer from './reports/reports.slice';
import googleWorkspaceReducer from './googleWorkspace/googleWorkspace.slice';
import whitelabelConfigReducer from './whitelabel/whitelabelConfig.slice';

// ----------------------------------------------------------------------

const rootReducer = combineReducers({
  customers: customersReducer,
  partners: partnersReducer,
  accountSetup: accountSetupReducer,
  relationshipManager: relationshipManagerReducer,
  users: usersReducer,
  teams: teamsReducer,
  whatsApp: whatsAppReducer,
  gmb: gmbReducer,
  reports: reportsReducer,
  googleWorkspace: googleWorkspaceReducer,
  whitelabelConfig: whitelabelConfigReducer,
});

export default rootReducer;
